import React from "react";
import { Button } from "antd";
import { ClockCircleOutlined, RollbackOutlined, StopOutlined } from "@ant-design/icons";
import { useResume } from "./services/ResumeProvider";

const bannerStyle = {
  background: "linear-gradient(90deg, #e8f2ff 0%, #f5faff 100%)",
  border: "1px solid #d6e4ff",
  borderRadius: 10,
  padding: "12px 16px",
  display: "flex",
  alignItems: "center",
  gap: 12,
  margin: "12px 16px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
  color: "#1f2d3d",
};

const ResumeBanner = () => {
  const { resumeOffer, acceptResume, ignoreResume } = useResume();

  if (!resumeOffer) return null;

  const savedAt = resumeOffer?.savedAt
    ? new Date(resumeOffer.savedAt).toLocaleString()
    : "";

  return (
    <div style={bannerStyle}>
      <ClockCircleOutlined style={{ color: "#1d39c4", fontSize: 18 }} />
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600 }}>
          Reprendre là où vous vous êtes arrêté ?
        </div>
        <div style={{ fontSize: 13, color: "#334155" }}>
          {resumeOffer?.summary || "Session en cours"} · {resumeOffer?.path}{" "}
          {savedAt ? ` · ${savedAt}` : ""}
        </div>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <Button
          type="primary"
          icon={<RollbackOutlined />}
          onClick={acceptResume}
          size="small"
        >
          Reprendre
        </Button>
        <Button
          danger
          ghost
          icon={<StopOutlined />}
          onClick={ignoreResume}
          size="small"
        >
          Ignorer
        </Button>
      </div>
    </div>
  );
};

export default ResumeBanner;
